<template>
	<div>
		<div class="project" :class="{ 'is-guided-tutorial-on': isGuidedTutorialOn }" style="overflow: hidden; min-height: 600px">
			<ProjectTopBar class="width-100" style="position: fixed; width: 100%" :projectIdToReturn="projectIdToReturn" :projectId="pID" />
			<router-view />
		</div>
		<InAppInjectables />
	</div>
</template>

<script>
import { waitUntil } from 'async-wait-until';
import { mapActions, mapGetters } from 'vuex';

import { ProjectTopBar } from '@/components/Project/TopBar';
import { getProjectCredentials } from '@/store/modules/credentials/actions';
import { isInAppHelpEnabled } from '@/store/modules/featureFlags/getters';
import { isGuidedTutorialOn } from '@/store/modules/onboarding/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import IntercomService from '@/utils/IntercomService';
import { ALL_PROJECTS_VIRTUAL_ID } from '@/utils/projects.const';
import InAppInjectables from '@/views/common/InAppInjectables';

export default {
	name: 'Project',
	components: {
		ProjectTopBar,
		InAppInjectables,
	},
	async mounted() {
		this.waitForIntercom();
		await this['selectedProject/selectProjectId']({ id: this.pID });
		this.getProjectCredentials({ projectId: this.pID });
	},
	props: {
		pID: { type: Number, required: true },
		projectIdToReturn: { type: [Number, String], default: ALL_PROJECTS_VIRTUAL_ID },
	},
	async created() {},
	computed: {
		...mapGetters(['isLoggedIn', 'selectedProject/selectedProjectFlows', isInAppHelpEnabled.fullPath]),
		...mapGettersShorthand({ isGuidedTutorialOn }),
		flows() {
			return this['selectedProject/selectedProjectFlows'];
		},
		isProjectRoute() {
			return this.$route.name === 'Project';
		},
		newFlowRoute() {
			return this.$route.name === 'NewFlow';
		},
	},
	watch: {
		flows: {
			handler(newV) {
				if (newV && Array.isArray(newV)) {
					this.$set(this, 'localFlows', newV);
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		...mapActions(['selectedWorkflow/createAndSelectWorkflow', 'selectedProject/selectProjectId']),
		...mapActionsShorthand({ getProjectCredentials }),
		createFlow() {
			this['selectedWorkflow/createAndSelectWorkflow']({ workflow: { workflow_title: '' } });
		},
		async waitForIntercom() {
			// console.log(`waiting for intercom to boot`);
			try {
				await waitUntil(() => IntercomService.loaded() && IntercomService.booted(), { timeout: 10000 });
			} catch (err) {
				console.log(`waitForIntercom:`, err);
			}
			// console.log(`Intercom booted`);
			this.showIntercom();
		},
		showIntercom() {
			if (!this[isInAppHelpEnabled.fullPath]) {
				IntercomService.update({ hide_default_launcher: false }, false);
			}
		},
	},
	data: () => ({
		flow: null,
		localFlows: [],
	}),
};
</script>

<style scoped lang="scss">
.project {
	min-width: 1024px;
	min-height: 600px;

	&:not(.is-guided-tutorial-on) {
		height: 100vh;
	}
	&.is-guided-tutorial-on {
		height: calc(100vh - #{$bottom-player-bar-height});
	}
}
.flow_view {
	position: absolute;
	top: 58px;
	bottom: 0px;
	left: 0px;
	right: 0px;
	background: transparent;
}
.side_bar {
	position: absolute;
	top: 0px;
	right: 0px;
	height: 100%;
	transition: all 0.3s;
}
.side_bar.closed {
	transform: translateX(101%);
}
.side_bar.action {
	transform: translateX(0);
}
.side_bar.widget {
	transform: translateX(0);
}
.flow_canvas {
	transition: all 0.3s;
}
.control_panel {
	position: absolute;
	left: 0px;
	top: 80px;
	width: auto;
	width: 580px;
	height: 200px;
}
</style>
